module.exports = __webpack_public_path__ + "static/theclock_white-8a20b9f3b37f487c380ad4de6ca50582.webp";